/**
 * BootstrapVue hardcodes `aria-describedby` on every modal dialog to the id of
 * the whole modal body (`computedModalAttrs` in bootstrap-vue's modal.js) and
 * offers no prop to turn it off. When the body holds several unrelated blocks
 * rather than one descriptive sentence, screen readers repeat that whole text
 * on every focus move inside the dialog.
 *
 * Call it from the modal's `@shown` handler: the dialog element exists only
 * once the modal is rendered, and it is recreated on every open, so the
 * attribute has to be dropped again each time. Vue keeps the removal across
 * later patches because the value in the virtual DOM never changes.
 */
export const removeModalDescription = (modalId: string) => {
  document.getElementById(modalId)?.removeAttribute('aria-describedby');
};
